// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
// import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import initHeadlineReveal from "./headline-reveal";
import initNavigation from "./nav";
import animation from "./animation.js";
import initProjectsScroll from "./projects-scroll.js";
import initEyeTrack from "./eye-track.js";
import initMascotBlink from "./mascot-blink.js";
import initPodcastLinks, { formatEpisodeExcerpt } from "./podcast-links.js";



// Call the menu and infinite scroll functions
// menuOpen();
infiniteScroll();
animation();
initNavigation();
initHeadlineReveal();
initProjectsScroll();
initEyeTrack();
initMascotBlink();
initPodcastLinks();
formatEpisodeExcerpt();